import React, { Fragment } from "react";
import Head from "../../../layout/Head";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import blog from "../../../Data/blog";
import { useParams } from "react-router-dom";

const BlogDetails = () => {
  const { id } = useParams();

  const blogData = blog.find((data) => data.id === id);
  console.log(blogData);
  return (
    <Fragment>
      <Head
        Title="About"
        href="/about"
        description="IT Services Providers are companies that offer a range of IT services and solutions to help organizations manage their technology infrastructure | About Pages"
      />
      <Header />

      <div className="container mx-auto px-2">
        <section className="grid max-md:grid-cols-3 mt-12">
          <main className="col-span-2 relative max-md:mr-2">
            <h1 className="text-3xl font-bold text-gray-800">
              {blogData.title}
            </h1>
            <div className="flex mt-2 my-2 items-center gap-4">
              <div className="w-10 h-10 bg-gray-300 rounded-full">
                <img
                  src={blogData.author.image}
                  class="cursor-pointer"
                  alt="placeholder tag"
                />
              </div>
              <div className="text-gray-500">
                By{" "}
                <span className="text-gray-800 cursor-pointer">
                  {blogData.author.fullName}
                </span>{" "}
                on {blogData.date}
              </div>
            </div>

            <div className="flex justify-center border">
              <img
                src={blogData.images[1]}
                className="cursor-pointer"
                alt="placeholder tag"
              />
            </div>
            <blockquote className="italic font-semibold font-serif text-gray-800 border-l-4 border-gray-900 my-3 pl-2 ml-8">
              {blogData.description}
            </blockquote>
            <article>
              <section>
                <p className="my-4">{blogData.des.des1}</p>

                <p className="my-4">{blogData.des.des2}</p>
              </section>

              <section>
                <p className="my-4">{blogData.des.des3}</p>

                <p className="my-4">{blogData.des.des4}</p>
              </section>

              <section>
                <p className="my-4">{blogData.des.des5}</p>

                <p className="my-4">{blogData.des.des6}</p>
              </section>

              <section>
                <p className="my-4">{blogData.des.des7}</p>

                <p className="my-4">{blogData.des.des8}</p>
              </section>
              <section>
                <p className="my-4">{blogData.des.des9}</p>

                <p className="my-4">{blogData.des.des10}</p>
              </section>
            </article>
            <form id="comment">
              <textarea
                placeholder="your comment"
                cols="5"
                rows="6"
                className="outline-none focus:outline-none text-xl bg-[#e0e0e0] rounded p-4 text-[gray] font-semibold w-full"
              ></textarea>
              <input
                type="email"
                className="w-full bg-[#e0e0e0] p-2 my-2 px-4 text-xl text-[gray] rounded focus:outline-none"
                placeholder="your email"
                required="true "
              />
              <input
                type="text"
                className="w-full bg-[#e0e0e0] p-2 px-4 text-xl text-[gray] rounded focus:outline-none"
                placeholder="your name"
                required="true "
              />
              <button
                className="my-2 py-2 text-xl text-center w-full bg-primary text-[#fff] hover:bg-blue-600 focus:outline-none rounded"
                type="submit"
              >
                Comment
              </button>
            </form>
          </main>

          <aside className="col-span-2 max-md:col-span-1 mt-4 max-md:mt-0">
            <div className="max-mb-8 ">
              <p className="text-3xl font-semibold border-l-4 border-[gray] pl-2 my-8 text-[#a7a7a7]">
                Explore Categories
              </p>
              <ul className="ml-3 text-lg font-semibold text-gray-700">
                <li className="border py-2 px-2 mt-2 mb-1 cursor-pointer hover:text-[gray] rounded-sm flex justify-between">
                  Full Stack Development{" "}
                  <span className="text-gray-900">100</span>
                </li>
                <li className="border py-2 px-2 mt-2 mb-1 cursor-pointer hover:text-gray-900 rounded-sm flex justify-between">
                  Digital Marketing <span className="text-gray-900">5</span>
                </li>
                <li className="border py-2 px-2 mt-2 mb-1 cursor-pointer hover:text-gray-900 rounded-sm flex justify-between">
                  Graphic Design <span className="text-gray-900">11</span>
                </li>
                <li className="border py-2 px-2 mt-2 mb-1 cursor-pointer hover:text-gray-900 rounded-sm flex justify-between">
                  Video Editing <span className="text-gray-900">8</span>
                </li>
              </ul>
            </div>
            <div className="flex flex-col items-center my-8">
              <p className="text-3xl font-semibold border-l-4 my-8 border-gray-800 pl-2 text-gray-700 self-start">
                About Author
              </p>

              <div>
                <div className="w-48 h-48 bg-gray-900 bg-author-img bg-contain bg-no-repeat bg-center rounded-full">
                  <img
                    src={blogData.author.image}
                    class="cursor-pointer"
                    alt="placeholder tag"
                  />
                </div>
              </div>
              <div>
                <p
                  id="author-name"
                  className="text-2xl text-center font-medium my-4 text-gray-800"
                >
                  {blogData.author.fullName}
                </p>
                <p className="my-1 text-gray-600 text-center">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Non
                  libero nam sit! Maxime omnis expedita sequi sapiente
                  consequatur praesentium quae voluptates explicabo deleniti
                  asperiores. Nemo id soluta fuga tenetur ex?
                </p>
              </div>
            </div>
          </aside>
        </section>
      </div>

      <Footer />
    </Fragment>
  );
};

export default BlogDetails;
